function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100,
  viewBox: "0 0 100 100",
  role: "img"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36 65c-8.284 0-15-6.716-15-15s6.716-15 15-15 15 6.716 15 15-6.716 15-15 15m0-6.774a8.226 8.226 0 1 0 0-16.452 8.226 8.226 0 0 0 0 16.452"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M62.014 53.498H55.5v-8.781h6.574l-.863-4.764a2 2 0 0 1 3.11-2L79.04 48.175a1 1 0 0 1 0 1.642l-14.732 10.23a2 2 0 0 1-3.11-1.995z"
})));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/directions/ic-head-towards.svg";
export { SvgComponent as ReactComponent };